import auth from '../services/auth';
import routing from '../services/routing';
import { CONFIRM_REQUEST_EMAIL_CHANGE, CONFIRM_EMAIL_CHANGE } from '../constants/routes';
import { CHANGE_EMAIL_REQUEST_REQUIRED } from '../constants/actions';
import { CHANGE_EMAIL_FLOW_V2 } from '../constants/auth';

export default async (formData: { newEmail: string; confirmNewEmail: string }) => {
    if (formData.newEmail !== formData.confirmNewEmail) {
        throw new Error('Emails do not match');
    }

    const res = CHANGE_EMAIL_FLOW_V2
        ? await auth.requestEmailChange({ newEmail: formData.newEmail })
        : await auth.changeEmail({ email: formData.newEmail });
    if (res?.data?.challengeName === CHANGE_EMAIL_REQUEST_REQUIRED) {
        routing.push(CONFIRM_REQUEST_EMAIL_CHANGE);
    } else {
        routing.push(CONFIRM_EMAIL_CHANGE);
    }
};
